/**
 * Firebase Environment Configuration - Staging
 * 
 * This file contains the Firebase configuration for the staging environment.
 */

const environment = 'staging';

const config = {
  apiKey: 'AIzaSyDyevvkeTg5XczbMJs2ABuRwLRIdvU9SFg',
  authDomain: 'gantty-staging.firebaseapp.com',
  projectId: 'gantty-staging',
  storageBucket: 'gantty-staging.firebasestorage.app',
  messagingSenderId: '377853810384',
  appId: '1:377853810384:web:0d985189a775bfb001f0d5',
  measurementId: 'G-5MXZJ99E3F',
};

// Cloud Function URLs
const execSummaryFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/generateExecutiveSummary';
const changeSummaryFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/generateChangeSummary';
const exportUserDataFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/exportUserData';
const deleteUserWithErasureReportFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/deleteUserWithErasureReport';
const chatbotFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/chatbotDataset';
const holidaysFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/holidaysApi';
const datasetAccessRequestFunctionUrl = 'https://europe-west1-gantty-staging.cloudfunctions.net/datasetAccessRequest';

// Export for backward compatibility
export default {
  environment,
  config,
  execSummaryFunctionUrl,
  changeSummaryFunctionUrl,
  exportUserDataFunctionUrl,
  deleteUserWithErasureReportFunctionUrl,
  chatbotFunctionUrl,
  holidaysFunctionUrl,
  datasetAccessRequestFunctionUrl,
};

export { environment, config, execSummaryFunctionUrl, changeSummaryFunctionUrl, exportUserDataFunctionUrl, deleteUserWithErasureReportFunctionUrl, chatbotFunctionUrl, holidaysFunctionUrl, datasetAccessRequestFunctionUrl };
